import cn from 'classnames'
import { IconCross } from 'lib/icons/Icon'

const TextInput = ({
  label,
  containerStyles,
  containerclass,
  labelClass,
  inputclass,
  adornment,
  onReset,
  onChange,
  value,
  automaticClean = true,
  ...props
}) => {
  const handleClean = () => {
    if (typeof onReset === 'function') {
      onReset()
    } else if (typeof onChange === 'function') {
      onChange({
        target: {
          name: props.name,
          value: '',
        },
      })
    }
  }

  return (
    <div
      style={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        fontSize: '12px',
        fontWeight: '600',
        ...containerStyles,
      }}
      className={containerclass}
    >
      {label && <label className={cn(labelClass)}>{label}</label>}

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          background: !props.disabled ? 'white' : undefined,
        }}
        className="custom-input-container"
      >
        <input
          {...props}
          value={value}
          onChange={onChange}
          className={cn('custom-input', inputclass)}
          style={{ minWidth: 'auto' }}
        />

        {!adornment &&
          value !== '' &&
          value !== undefined &&
          value !== null &&
          (onReset || onChange) && (
            <div
              style={{ padding: '1rem', cursor: 'pointer' }}
              onClick={handleClean}
            >
              <IconCross />
            </div>
          )}

        {adornment && (
          <div
            style={{
              display: 'flex',
              padding: '1rem',
              color: '#555',
              fontWeight: '400',
              cursor: onReset ? 'pointer' : 'default',
            }}
            onClick={automaticClean && handleClean}
          >
            {adornment}
          </div>
        )}
      </div>
    </div>
  )
}

export default TextInput
